import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-green-50/30 to-white"
    >
      {/* Background with glow effect */}
      <div className="absolute inset-0 hero-glow" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-40">
        <div className="max-w-4xl">
          {/* Label */}
          <div
            className="opacity-0 animate-fade-up"
            style={{ animationDelay: '0.1s', animationFillMode: 'forwards' }}
          >
            <span className="font-manrope uppercase tracking-widest text-xs font-semibold text-primary">
              Growth Agency
            </span>
          </div>

          {/* Main Heading */}
          <h1
            className="font-oswald uppercase tracking-tight font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] mt-6 opacity-0 animate-fade-up"
            style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}
            data-testid="hero-headline"
          >
            <span className="text-gray-900">All good collaborations start with a conversation.</span>
            <br />
            <span className="text-primary">We build growth systems.</span>
          </h1>

          {/* Subtext */}
          <div
            className="mt-8 md:mt-10 max-w-2xl opacity-0 animate-fade-up"
            style={{ animationDelay: '0.3s', animationFillMode: 'forwards' }}
          >
            <p className="font-manrope text-base md:text-lg text-gray-500 leading-relaxed">
              Most agencies sell campaigns or content output.
            </p>
            <p className="font-manrope text-base md:text-lg text-gray-700 mt-4 leading-relaxed">
              We build growth systems. We connect strategy, content, creators, distribution, and monetization into one long-term engine.
            </p>
          </div>

          {/* CTA */}
          <div
            className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-up"
            style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
          >
            <a
              href="https://calendly.com/atabdullah-mah/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-book-call"
            >
              <Button className="bg-primary text-white hover:bg-primary/90 rounded-full px-8 py-6 text-lg font-bold uppercase tracking-wide btn-scale glow-primary flex items-center gap-2">
                Book a Call
                <ArrowRight size={20} />
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-fade-up" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
        <div className="w-6 h-10 border-2 border-gray-300 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-primary rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
};
